import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { productSheetsAPI, CreateProductSheetRequest, UpdateProductSheetRequest } from '../api';

export const useGetProductSheets = (search?: string) => {
  return useQuery({
    queryKey: ['productSheets', search],
    queryFn: () => productSheetsAPI.getAllProductSheets(search),
  });
};

export const useGetProductSheetById = (id: string) => {
  return useQuery({
    queryKey: ['productSheet', id],
    queryFn: () => productSheetsAPI.getProductSheetById(id),
    enabled: !!id,
  });
};

export const useCreateProductSheet = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (data: CreateProductSheetRequest) => productSheetsAPI.createProductSheet(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['productSheets'] });
    },
  });
};

export const useUpdateProductSheet = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateProductSheetRequest }) => 
      productSheetsAPI.updateProductSheet(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['productSheets'] });
    },
  });
};

export const useDeleteProductSheet = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (id: string) => productSheetsAPI.deleteProductSheet(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['productSheets'] });
    },
  });
};

export const useDownloadProductSheet = () => {
  return useMutation({
    mutationFn: (id: string) => productSheetsAPI.downloadProductSheet(id),
    onSuccess: (data) => {
      if (data?.data?.downloadUrl) {
        window.open(data.data.downloadUrl, '_blank');
      }
    },
  });
};
